import { render, staticRenderFns } from "./SubportionSection.vue?vue&type=template&id=6bbf2008&scoped=true&"
import script from "./SubportionSection.vue?vue&type=script&lang=js&"
export * from "./SubportionSection.vue?vue&type=script&lang=js&"
import style0 from "./SubportionSection.vue?vue&type=style&index=0&id=6bbf2008&lang=scss&scoped=true&"
import style1 from "./SubportionSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf2008",
  null
  
)

export default component.exports